import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { MessageHandlerService } from '../../utility/message-handler.service';
import { GridDataService } from './grid-data.service';

@Injectable()
export class AssessmentFulfillmentListService extends GridDataService
{
    constructor(http: HttpClient, translate: TranslateService, messageHandlerService: MessageHandlerService)
    {
        super(http, '/assessment/fulfillments', translate, messageHandlerService);
    }
}
